import { Observable, Observer } from 'rxjs';

import { Transaction } from '../transaction/transaction';

export abstract class MemoryCacheRepository<T> {
    private data: T = null;

    load(): Observable<Transaction<T>> {
        return new Observable((observer: Observer<Transaction<T>>) => {
            if (this.data) {
                observer.next(Transaction.success(this.data));
            }
            observer.complete();
        });
    }

    save(value: T): Observable<void> {
        return new Observable((observer: Observer<void>) => {
            this.data = value;
            observer.complete();
        });
    }

    clear(): Observable<void> {
        return new Observable((observer: Observer<void>) => {
            this.data = null;
            observer.complete();
        });
    }
}
